import { type ComunicazioneDTO } from '@framework/api-client/api/backoffice/schemas/comunicazioneDTO.ts';
import { CommunicationActorsContainer } from './CommunicationActorsContainer.tsx';
import { CommunicationRecipientsView } from './CommunicationRecipientsView.tsx';
import { CommunicationSenderView } from './CommunicationSenderView.tsx';

export interface ICommunicationActorsViewProps {
  communication: ComunicazioneDTO | null | undefined;
}

/**
 * Attori di una comunicazione
 */
export function CommunicationActorsView(props: ICommunicationActorsViewProps) {
  const { communication } = props;
  if (!communication) return null;

  return (
    <CommunicationActorsContainer
      showDivider={false}
      from={<CommunicationSenderView communication={communication} />}
      to={<CommunicationRecipientsView communication={communication} />}
    />
  );
}
